module.exports = __webpack_public_path__ + "assets/5adab680ced3da1126f89ddadf73defc.svg";